import React from 'react';
import { ConnectedRouter } from 'connected-react-router';

import history from './store/history';
import MainRouter from './MainRouter';

const App = () => (
  <div className="up">
    <ConnectedRouter history={history}>
      <MainRouter />
    </ConnectedRouter>
  </div>
);

export default App;
